// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"flag-3"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 9.99998L9 16.9282L9 3.07178L21 9.99998Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 2L5 22M21 9.99998L9 16.9282L9 3.07178L21 9.99998Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Flag3Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'flag-3',
    ref,
    icon: element,
  },
));

Flag3Icon.displayName = 'Flag3Icon';

export default Flag3Icon;
